import { ApiService } from '../../root-services/api.service';
import { TimezoneService } from './../../shared/services/timezones.service';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { EditionService } from './../../shared/services/edition.service';
import { EditionListService } from '../../editions/edition.service';
import { ErrorService } from './../../shared/services/error.service';
import { CurrentUserService } from './../../shared/services/current-user.service';
import { SAMLProviderListItem } from './saml-provider-list-item';
import { AuthSettingsService } from './auth-settings.service';

import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-provider-list',
  templateUrl: './provider-list.component.html',
  styleUrls: ['./provider-list.component.less']
})

export class ProviderListComponent implements OnInit, OnDestroy {
  @ViewChild('form') form: ElementRef;

  public providers: SAMLProviderListItem[];
  private subs: Subscription[] = [];

  constructor(
    private editionList: EditionListService,
    private editionService: EditionService,
    private errorService: ErrorService,
    private authSettingsService: AuthSettingsService,
  ) { }

  public ngOnInit(): void {
    this.subs.push(this.editionList.waitForEdition().subscribe(() => {
      this.getProviders();
    }));
  }

  public ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  /**
   * Private Methods
   */

  private getProviders(): void {
    this.editionService.getEdition()
      .subscribe(edition => {
        this.authSettingsService.getProviders(edition.id).subscribe(providers => this.providers = providers);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/auth-settings/provider-list.component.ts